module.exports = __webpack_public_path__ + "img/theory1.adef9c75.gif";